import React from 'react';
import COLORS from '../../../../constants/colors';
import FONTS from '../../../../constants/fonts';
import Text from '../../../content/text';
import { Stack } from '@chakra-ui/react';
import moment from 'moment';
const EventCardDate = ({ date, ...props }) => {
    return (<Stack p={'.5rem'} alignItems={'center'} justifyContent={'center'} textAlign={'center'} borderRadius={'.5rem'} spacing={0} minW={'3.0rem'} backgroundColor={COLORS.White.T500.value} borderWidth={1} borderColor={COLORS.Line.value} {...props}>
      <Text font={FONTS.T1.T16Px.SemiBold600.value} color={COLORS.Error.T500.value} style={{ textAlign: 'center' }}>
        {moment(date).format('DD')}
      </Text>
      <Text font={FONTS.T1.T12Px.Medium500.value} color={COLORS.Text.T400.value} numberOfLines={2} style={{ textAlign: 'center' }}>
        {`${moment(date).format('MMM')} ${moment(date).format('YYYY')}`}
      </Text>
    </Stack>);
};
export default EventCardDate;
